import { saveContentAsPdf } from './contentToPdf/saveContentAsPdf'
import { showLoader } from './loader'
import { isOnDailyPage, pageId, logId, isOnMainLogPage, isOnEditableDailyPage } from '../fromPhp'
import { sortConstructionLogJson } from './constructionLog'
import { getLogPageForm, getFormUrl } from '../get-log-page-form'
import { ajax } from 'jquery'
import { htmlDisable, htmlEnable, htmlIded, htmlOnClick } from '../fun-js-lib/html'
import { isPageHasChanges, unsetPageHasChanges } from '../page-has-changes'
import { isContentFilledCorrectly, onInputInContent } from '../validation/content'
import { addHint, removeHint, contentHint, changeHint } from '../validation/hint'
import { hideLoader } from './loader'
import {selectAll} from "d3-selection";
import {isSet} from "lodash/lang";

export const initPdfIfNeed = () => {
  if (isOnDailyPage() && hasPrintButtonOnDailyPage()) {
    htmlOnClick(htmlIded('print-page'), sendIfNeedAndPrintPage)
    onCtrlP(sendIfNeedAndPrintPage)
    if (isOnEditableDailyPage()) {
      addHint(printPageContainer(), '', 'bottom')
      onInputInContent(validate)
      validate()
    }
  } else {
    initWholeLogPrint()
  }
}

function initWholeLogPrint () {
  if (isOnMainLogPage()) {
    const mainLogPrintButton = htmlIded('print-construction-log')
    htmlOnClick(mainLogPrintButton, event => {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault()
      }
      if (mainLogPrintButton.classList.contains('disabled') || mainLogPrintButton.getAttribute('aria-disabled') === 'true') {
        return
      }
      const useBackend = mainLogPrintButton.dataset.backendPdf === '1'
      const isDigital = mainLogPrintButton.dataset.isDigital === '1'
      const idFromData = (mainLogPrintButton.dataset.logId || '').trim()
      printLog(idFromData || logId(), useBackend, isDigital)
    })
    onCtrlP(() => {
      if (mainLogPrintButton.classList.contains('disabled') || mainLogPrintButton.getAttribute('aria-disabled') === 'true') {
        return
      }
      const useBackend = mainLogPrintButton.dataset.backendPdf === '1'
      const isDigital = mainLogPrintButton.dataset.isDigital === '1'
      const idFromData = (mainLogPrintButton.dataset.logId || '').trim()
      printLog(idFromData || logId(), useBackend, isDigital)
    })
  }

  selectAll('.print-construction-log').each(function () {
    htmlOnClick(this, function () {
      if (this.classList.contains('disabled') || this.getAttribute('aria-disabled') === 'true') {
        return
      }
      const useBackend = this.dataset.backendPdf === '1'
      const isDigital = this.dataset.isDigital === '1'
      const dataLogId = (this.dataset.logId || '').trim()

      if (dataLogId !== '') {
        printLog(dataLogId, useBackend, isDigital)
        return
      }

      const tdParent = this.closest('td')
      if (!tdParent) {
        return
      }

      const itemIdSpan = tdParent.querySelector('.itemId')
      if (itemIdSpan) {
        const logId = itemIdSpan.textContent.trim()
        printLog(logId, useBackend, isDigital)
      }
    });
  });
}

function validate () {
    if (isContentFilledCorrectly()) {
      enableDailyPrint()
    } else {
      disableDailyPrint()
    }
}

function enableDailyPrint () {
  removeHint(printPageContainer())
  htmlEnable(htmlIded('print-page'))
}

function disableDailyPrint () {
  htmlDisable(htmlIded('print-page'))
  changeHint(printPageContainer(), contentHint)
}

const printPageContainer = () =>
  htmlIded('print-page-container')

export const hasPrintButtonOnDailyPage = () =>
  htmlIded('print-page') !== null

/**
 * @param {() => any} f 
 */
function onCtrlP (f) {
  window.addEventListener('keydown', event => {
    if (event.ctrlKey && event.key === 'p') {
      f()
      event.preventDefault()
    }
  })
}

function printLog(id = null, useBackend = false, isDigital = false) {
  if (id instanceof PointerEvent) {
    id = logId()
  }
  if (useBackend && id) {
    if (isDigital) {
      window.location.href = '/download-log/' + id
    } else {
      startPdfExport(id)
    }
    return
  }
  let url = '/api/log/' + (id ?? logId())
  fetch(url)
    .then(response => response.json())
    .then(printData)
  showLoader()
}

function startPdfExport(id) {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]')
  fetch(`/logs/${encodeURIComponent(id)}/pdf-exports`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': csrfMeta ? csrfMeta.getAttribute('content') : ''
    },
    body: JSON.stringify({})
  })
    .then(async response => {
      const payload = await response.json()
      if (!response.ok) {
        throw new Error(payload.message || 'Izvoz PDF dokumenta nije moguće pokrenuti.')
      }
      return payload
    })
    .then(payload => {
      const jobs = Array.isArray(payload.jobs) ? payload.jobs : []
      jobs.forEach(job => {
        if (typeof window.addActiveJob === 'function') window.addActiveJob(job)
        if (typeof createOrUpdateCopyToast === 'function') {
          createOrUpdateCopyToast(job.token, job.log_name || '', 'pdf-export')
        }
        if (!window.__useBulkPolling && typeof startPollingPdfExportProgress === 'function') {
          startPollingPdfExportProgress(job.token)
        }
      })
    })
    .catch(error => showFlashError(error.message || 'Izvoz PDF dokumenta nije moguće pokrenuti.'))
}

function sendPage () {
  return new Promise((resolve, reject) => {
    ajax({
      type: 'POST',
      url: getFormUrl(),
      data: getLogPageForm(),
      success: resolve,
      error: reject,
      cache: false,
      contentType: false,
      processData: false
    })
  })
}

function sendIfNeedAndPrintPage () {
  let url = '/api/page/' + pageId()
  let href = htmlIded('print-page').dataset.href
  const errorText = 'Greška prilikom štampanja. Nemoguće odštampati stranicu.'
  if(href){
    if (isPageHasChanges()) {
      sendPage()
        .then(() => {
          hideLoader();
          window.location.href = href
        })
        .catch(() => {
          hideLoader();
          showFlashError(errorText)
        })
      showLoader()
    } else{
      console.log('here')
      window.location.href = href
    }
  }else {
    if (isPageHasChanges()) {
      sendPage()
        .then(() => fetch(url))
        .then(response => response.json())
        .then(printData)
        .catch(() => showFlashError(errorText))
      unsetPageHasChanges()
    } else {
      fetch(url)
        .then(response => response.json())
        .then(printData)
        .catch(() => showFlashError(errorText))
    }
    showLoader()
  }
}

/**
 * @param {string} errorText 
 */
export function showFlashError (errorText) {
  let large = '<div class="alert alert-danger alert-dismissible fade show mb-0 fade-in-onload z-index-n1" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close">    <span aria-hidden="true">×</span></button><i class="fa fa-exclamation mx-2"></i>' + errorText + '</div>'
  document.getElementById('mainNavbar').insertAdjacentHTML('afterend', large)
  hideLoader()
}

/**
 * @param {import('./constructionLog').ConstructionLog} json 
 */
export const printData = json => {
  sortConstructionLogJson(json)
  saveContentAsPdf(json)
}

